import { motion } from "framer-motion";
import { Trophy, Clapperboard, Film, Baby } from "lucide-react";
import { CATEGORIES } from "../../data/site";
import { Reveal, SectionHead } from "./Reveal";

const ICONS = { Trophy, Clapperboard, Film, Baby };

export default function Categories() {
  return (
    <section id="kategoriler" className="relative bg-[#0d0b3d] py-24 md:py-36" data-testid="categories-section">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHead kicker="İçerik Kategorileri" title={<>Ne izlemek<br />istersen.</>} testid="categories-title"
          sub="Spor, film, dizi ve çocuk kanalları tek pakette. 500.000+ içerikten bazı örnekler:" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {CATEGORIES.map((c, i) => {
            const Icon = ICONS[c.icon];
            return (
              <Reveal key={c.id} delay={i * 0.08} className="h-full">
                <motion.div whileHover="hover" initial="rest" animate="rest"
                  className="group relative h-full min-h-[380px] overflow-hidden rounded-[28px] border border-white/10 p-7 flex flex-col hover:border-[#8a8dff] transition-colors" data-testid={`category-card-${c.id}`}>
                  <motion.img src={c.img} alt={c.title} loading="lazy" variants={{ rest: { scale: 1.05 }, hover: { scale: 1.14 } }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="absolute inset-0 h-full w-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#08072a] via-[#0d0b3d]/80 to-[#0d0b3d]/30" />
                  <div className="relative flex items-center justify-between">
                    <span className="grid h-12 w-12 place-items-center rounded-2xl bg-white/10 backdrop-blur text-white group-hover:bg-[#5b5fd6] transition-colors">
                      <Icon size={22} />
                    </span>
                    <span className="font-display text-sm text-white/80">0{i + 1}</span>
                  </div>
                  <h3 className="relative font-display text-2xl md:text-3xl font-extrabold uppercase mt-auto pt-16">{c.title}</h3>
                  <div className="relative mt-4 flex flex-wrap gap-2">
                    {c.channels.map((ch) => (
                      <span key={ch} className="rounded-full border border-white/20 bg-[#08072a]/60 backdrop-blur px-3 py-1.5 text-sm text-white">{ch}</span>
                    ))}
                  </div>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
